import { render, staticRenderFns } from "./release-user.vue?vue&type=template&id=71d34c89&scoped=true&"
import script from "./release-user.vue?vue&type=script&lang=js&"
export * from "./release-user.vue?vue&type=script&lang=js&"
import style0 from "./release-user.vue?vue&type=style&index=0&id=71d34c89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d34c89",
  null
  
)

export default component.exports